
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"24","viewBox":"0 0 24 24","width":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"clip-rule":"evenodd","d":"m10.5 16.5c-3.58985 0-6.5-2.9101-6.5-6.5 0-3.58985 2.91015-6.5 6.5-6.5 3.5899 0 6.5 2.91015 6.5 6.5 0 1.4945-.5044 2.8713-1.3523 3.9692l4.1082 4.1082c.3255.3254.3255.8531 0 1.1785-.3254.3255-.8531.3255-1.1785 0l-4.1082-4.1082c-1.0979.8479-2.4747 1.3523-3.9692 1.3523zm0-2c2.4853 0 4.5-2.0147 4.5-4.5 0-2.48528-2.0147-4.5-4.5-4.5-2.48528 0-4.5 2.01472-4.5 4.5 0 2.4853 2.01472 4.5 4.5 4.5z","fill":"#4a3428","fill-rule":"evenodd"}})])
          )
        }
      }
    